import { cn } from 'src/lib/utils'
import { CustomTypographyProps } from '../Types'

function P({ children, className }: CustomTypographyProps) {
    return (
        <p className={cn('leading-7 [&:not(:first-child)]:mt-2', className)}>{children}</p>
    )
}

export default P